import { useState, useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { RevenueTrendChart } from '../components/reports/RevenueTrendChart';
import { IncomeCategoryPieChart } from '../components/reports/IncomeCategoryPieChart';
import { RevenueTable } from '../components/reports/RevenueTable';
import { getRevenueReport, type RevenueReportData } from '../services/api';

export const Reports = () => {
  const year = new Date().getFullYear();
  const [data, setData] = useState<RevenueReportData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await getRevenueReport(year);
        setData(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar el reporte');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [year]);

  return (
    <div className="flex min-h-screen w-full flex-col p-6 bg-[#f6f7f8]">
      <Navbar showLogout={true} />

      <main className="flex flex-1 justify-center py-8">
        <div className="flex flex-col w-full max-w-6xl gap-8">

          {loading && (
            <div className="flex items-center justify-center py-24">
              <div className="flex flex-col items-center gap-3">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
                <p className="text-sm text-slate-500">Cargando reporte...</p>
              </div>
            </div>
          )}

          {error && !loading && (
            <div className="rounded-xl bg-red-50 border border-red-200 p-6">
              <p className="text-sm text-red-600 font-medium">{error}</p>
            </div>
          )}

          {data && !loading && (
            <>
              {/* Main trend chart */}
              <RevenueTrendChart
                months={data.months}
                yearTotal={data.year_total}
                monthlyAvg={data.monthly_avg}
                bestMonth={data.best_month}
                yoYChangePct={data.yoy_change_pct}
                currency={data.currency}
                year={data.year}
              />

              {/* Bottom grid */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <IncomeCategoryPieChart breakdown={data.category_breakdown} />
                <RevenueTable months={data.months} />
              </div>
            </>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};
